var _rect, _circle, _circle2, _circle3, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDownloadExtension = function SvgDownloadExtension(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4.999,
    y: 12,
    width: 78.667,
    height: 64,
    rx: 1.75,
    stroke: "currentColor",
    strokeWidth: 2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13.59,
    cy: 21.101,
    r: 3.926,
    fill: "currentColor"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 25.367,
    cy: 21.101,
    r: 3.926,
    fill: "currentColor"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 37.142,
    cy: 21.101,
    r: 3.926,
    fill: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.992 40.505h6.43v10.596h-3.987v-7.185h-3.572l1.129-3.41Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.333 67.13a7.333 7.333 0 1 0 0-14.667 7.333 7.333 0 0 0 0 14.667Zm0-3.33a4.004 4.004 0 1 0 0-8.007 4.004 4.004 0 0 0 0 8.008Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 2,
    d: "M9.499 29.25h73.334"
  })));
};
export { SvgDownloadExtension as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iODgiIGhlaWdodD0iODgiIHZpZXdCb3g9IjAgMCA4OCA4OCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3QgeD0iNC45OTkzMyIgeT0iMTIiIHdpZHRoPSI3OC42NjY3IiBoZWlnaHQ9IjY0IiByeD0iMS43NSIgc3Ryb2tlPSJjdXJyZW50Q29sb3IiIHN0cm9rZS13aWR0aD0iMiIvPgo8Y2lyY2xlIGN4PSIxMy41OSIgY3k9IjIxLjEwMSIgcj0iMy45MjU5OSIgZmlsbD0iY3VycmVudENvbG9yIi8+CjxjaXJjbGUgY3g9IjI1LjM2NzEiIGN5PSIyMS4xMDEiIHI9IjMuOTI1OTkiIGZpbGw9ImN1cnJlbnRDb2xvciIvPgo8Y2lyY2xlIGN4PSIzNy4xNDIzIiBjeT0iMjEuMTAxIiByPSIzLjkyNTk5IiBmaWxsPSJjdXJyZW50Q29sb3IiLz4KPHBhdGggZD0iTTM5Ljk5MTYgNDAuNTA1Mkg0Ni40MjE4VjUxLjEwMTVINDIuNDM1VjQzLjkxNjNIMzguODYzNUwzOS45OTE2IDQwLjUwNTJaIiBmaWxsPSJjdXJyZW50Q29sb3IiLz4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik00NC4zMzI3IDY3LjEyOTlDNDguMzgyOCA2Ny4xMjk5IDUxLjY2NiA2My44NDY2IDUxLjY2NiA1OS43OTY1QzUxLjY2NiA1NS43NDY0IDQ4LjM4MjggNTIuNDYzMiA0NC4zMzI3IDUyLjQ2MzJDNDAuMjgyNiA1Mi40NjMyIDM2Ljk5OTMgNTUuNzQ2NCAzNi45OTkzIDU5Ljc5NjVDMzYuOTk5MyA2My44NDY2IDQwLjI4MjYgNjcuMTI5OSA0NC4zMzI3IDY3LjEyOTlaTTQ0LjMzMjYgNjMuODAwNkM0Ni41NDQxIDYzLjgwMDYgNDguMzM2NyA2Mi4wMDc5IDQ4LjMzNjcgNTkuNzk2NUM0OC4zMzY3IDU3LjU4NTEgNDYuNTQ0MSA1NS43OTI0IDQ0LjMzMjYgNTUuNzkyNEM0Mi4xMjEzIDU1Ljc5MjQgNDAuMzI4NiA1Ny41ODUxIDQwLjMyODYgNTkuNzk2NUM0MC4zMjg2IDYyLjAwNzkgNDIuMTIxMyA2My44MDA2IDQ0LjMzMjYgNjMuODAwNloiIGZpbGw9ImN1cnJlbnRDb2xvciIvPgo8bGluZSB4MT0iOS40OTkzMyIgeTE9IjI5LjI1IiB4Mj0iODIuODMyNyIgeTI9IjI5LjI1IiBzdHJva2U9ImN1cnJlbnRDb2xvciIgc3Ryb2tlLXdpZHRoPSIyIi8+Cjwvc3ZnPgo=";